import { useState, useRef, useEffect } from 'react';

/**
 * Хук позволяет показывать/скрывать элементы в зависимости от пройденного скролла юзера.
 *
 * Условия изменения флага:
 *
 * - "Видимый" - если пользователь делает скролл вверх + `breakPoint`
 * - "Невидимый" - если пользователь делает скролл вниз + `breakPoint`
 *
 * @export
 * @param {number} breakPoint - количество пикселей, которое должен проскроллить юзер, чтобы
 * скрыть/показать элемент.
 */
export function useVisibleOnScroll(breakPoint: number) {
  const [visible, setVisible] = useState(true);
  const prevScreenPosition = useRef<number>(undefined);

  useEffect(() => {
    const handler = () => {
      // Определяем направление скролл вверх или вниз
      if ((prevScreenPosition.current as number) > window.pageYOffset) {
        // Если элемент уже является видимым, то просто обновляем предыдущую позицию.
        if (visible) {
          prevScreenPosition.current = window.pageYOffset;
          // Если элемент является невидимым, то ожидаем когда пользователь проскроллит нужное
          // количество пикселей.
        } else if ((prevScreenPosition.current as number) - window.pageYOffset >= breakPoint) {
          setVisible(true);
        }
      } else {
        if (!visible) {
          prevScreenPosition.current = window.pageYOffset;
        } else if (window.pageYOffset - (prevScreenPosition.current as number) >= breakPoint) {
          setVisible(false);
        }
      }
    };

    prevScreenPosition.current = window.pageYOffset;

    window.addEventListener('scroll', handler);

    return () => {
      window.removeEventListener('scroll', handler);
    };
  }, [breakPoint, visible]);

  return visible;
}
